// =============================================================
// 🧬 AvatarDistributionChart.jsx — Distribuição dos avatares
// =============================================================

import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

const COLORS = ["#f06292", "#ce93d8", "#4dd0e1", "#ffb74d", "#aed581"];

export default function AvatarDistributionChart({ data }) {
  if (!data || data.length === 0) {
    return <div className="ia-chart-empty">Sem dados suficientes ainda.</div>;
  }

  return (
    <div className="ia-chart-wrapper">
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie
            data={data}
            dataKey="count"
            nameKey="avatar"
            cx="50%"
            cy="50%"
            outerRadius={85}
            label
          >
            {data.map((entry, index) => (
              <Cell
                key={entry.avatar}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>

          <Tooltip />
          <Legend verticalAlign="bottom" height={40} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
